import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateProjectReportMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  periodStart: Types.Scalars['Date']['input'];
  periodEnd: Types.Scalars['Date']['input'];
}>;


export type CreateProjectReportMutationPage = { readonly __typename?: 'RootMutationType', readonly createProjectReport: { readonly __typename?: 'ProjectReport', readonly id: string, readonly status: Types.ProjectReportStatus, readonly errorReason?: Types.ProjectReportErrorReason | null } };


export const CreateProjectReportDocument = gql`
    mutation CreateProjectReport($companyId: ID!, $periodStart: Date!, $periodEnd: Date!) {
  createProjectReport(
    companyId: $companyId
    periodStart: $periodStart
    periodEnd: $periodEnd
  ) {
    id
    status
    errorReason
  }
}
    `;
export type CreateProjectReportMutationFn = Apollo.MutationFunction<CreateProjectReportMutationPage, CreateProjectReportMutationVariables>;

/**
 * __useCreateProjectReportMutation__
 *
 * To run a mutation, you first call `useCreateProjectReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectReportMutation, { data, loading, error }] = useCreateProjectReportMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *   },
 * });
 */
export function useCreateProjectReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectReportMutationPage, CreateProjectReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectReportMutationPage, CreateProjectReportMutationVariables>(CreateProjectReportDocument, options);
      }
export type CreateProjectReportMutationHookResult = ReturnType<typeof useCreateProjectReportMutation>;
export type CreateProjectReportMutationResult = Apollo.MutationResult<CreateProjectReportMutationPage>;
export type CreateProjectReportMutationOptions = Apollo.BaseMutationOptions<CreateProjectReportMutationPage, CreateProjectReportMutationVariables>;